module.exports = __webpack_public_path__ + "img/subject_02_106.jpg";